export function parseDate(dateString: string | null): Date | null {
  if (!dateString) {
    return null
  }
  const date = Date.parse(dateString)
  return isNaN(date) ? null : new Date(date)
}
